
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"6265cefb-52d3-40a7-a01a-9b493ad7ce16","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h40v40H0z","fill":"none"}}),_c('path',{attrs:{"d":"M35 35H23v-3h11V15H6v4H3V7a2 2 0 012-2h30a2 2 0 012 2v26a2 2 0 01-2 2zM34 8H6v4h28zM20 22v13H3V22h17z","fill-rule":"evenodd"}})])
          )
        }
      }
    